/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

'use client';

import React, { ComponentType, ReactNode } from 'react';

/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

/**
 * Cray Theme Default Layout Component
 * Standard layout for the base cray theme
 */

interface DefaultLayoutProps {
  children: ReactNode;
  Header: ComponentType;
  Footer: ComponentType;
  MobileNavigation: ComponentType;
}

export const DefaultLayout: React.FC<DefaultLayoutProps> = ({ children, Header, Footer, MobileNavigation }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#ffffff',
      }}
    >
      <Header />
      <MobileNavigation />
      <main style={{ flex: 1, padding: '1rem' }}>{children}</main>
      <Footer />
    </div>
  );
};

export default DefaultLayout;
